<template>
    <div class="chip-category">
        <img v-cloak v-show="item.Category == 'G'" src="@/assets/icon/search-result/ic-sr-garage.svg" alt=""/>
        <img v-cloak v-show="item.Category == 'D'" src="@/assets/icon/search-result/ic-sr-service.svg" alt=""/>
        <img v-cloak v-show="item.Category == 'W'" src="@/assets/icon/search-result/ic-sr-glass-shop.svg" alt=""/>
        <img v-cloak v-show="item.Category == 'H'" src="@/assets/icon/search-result/ic-sr-hospital.svg" alt=""/>
        <span class="lbl">{{ typeLabel }}</span>
    </div>
    <div class="text-a-black-484848 text-10 font-medium distance text-right">
        {{ tripDistance }} กม.
    </div>
</template>

<script>
import { defineComponent, computed, ref, watch } from 'vue';
import Utility from '@/helper/Utility';
import { calculateDistance } from "@/module/Maps/service/MapsService"

export default defineComponent({
    props: {
        item: {
            type: Object
        },
        coordinate: {
            type: Object,
            default: null
        }
    },
    setup: function (props) {
        const tripDistance = ref('0')

        const typeLabel = computed(() => {
            let lbl = ""
            switch (props.item.Category) {
                case "G":
                    lbl = "อู่ซ่อมรถ"
                    break;
                case "D":
                    lbl = "ศูนย์บริการ"
                    break;
                case "W":
                    lbl = "ร้านกระจก"
                    break;
                case "H":
                    lbl = "โรงพยาบาล"
                    break;

                default:
                    break;
            }

            return lbl
        })

        const updateDistance = function () {
            if (props.coordinate != null) {
                let destPos = {
                    lat: props.item.location.latitude,
                    lng: props.item.location.longitude
                }
                tripDistance.value = Utility.formatNum(calculateDistance(props.coordinate.lat, props.coordinate.lng, destPos.lat, destPos.lng), 1)
            }
        }

        watch(() => props.coordinate, (val) => {
            if (val != null) {
                updateDistance()
            }
        }, {
            immediate: true
        })

        return {
            typeLabel,
            tripDistance
        }
    }
})
</script>

<style lang="scss" scoped>
.chip-category {
    font-size: 9px;
    padding: 3px;
    @apply bg-a-gray-d0d0ce rounded-full font-light text-a-black-484848 flex gap-1 pr-2;

    .lbl {
        line-height: 15px;
    }

    img {
        width: 15px;
        height: 15px;
    }
}

.distance {
    min-width: 40px;
}
</style>
